// DetailsSection.js
import React from "react";
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import { People, Transgender, CalendarToday, MonetizationOn, LocationOn } from "@mui/icons-material";
import { formatDate } from "../../../utils/helpers";
import DetailsSectionSkeleton from "./DetailsSectionSkeleton";

const iconSx = { color: "#fff", minWidth: 40 };

const DetailsSection = ({ post, loading }) => {
  if (loading) return <DetailsSectionSkeleton />;

  return (
    <Box
      sx={{
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
        p: 3,
        mb: 4,
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: "#fff", fontSize: "1.1rem" }}>
        Details
      </Typography>

      <List dense sx={{ "& .MuiListItemText-primary": { color: "#fff", fontSize: "0.9rem" }, "& .MuiListItemText-secondary": { color: "rgba(255,255,255,0.7)", fontSize: "0.8rem" } }}>
        <ListItem>
          <ListItemIcon sx={iconSx}><MonetizationOn fontSize="small" /></ListItemIcon>
          <ListItemText primary={`₹${post.rent}/month`} secondary="Rent" />
        </ListItem>
        <Divider variant="inset" component="li" sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
        <ListItem>
          <ListItemIcon sx={iconSx}><LocationOn fontSize="small" /></ListItemIcon>
          <ListItemText primary={post.location} secondary="Location" />
        </ListItem>
        <Divider variant="inset" component="li" sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
        <ListItem>
          <ListItemIcon sx={iconSx}><People fontSize="small" /></ListItemIcon>
          <ListItemText primary={`${post.currentRoommates} current, ${post.neededRoommates} needed`} secondary="Roommates" />
        </ListItem>
        <Divider variant="inset" component="li" sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
        <ListItem>
          <ListItemIcon sx={iconSx}><Transgender fontSize="small" /></ListItemIcon>
          <ListItemText primary={post.expectedGender || "Any"} secondary="Preferred gender" />
        </ListItem>
        <Divider variant="inset" component="li" sx={{ borderColor: "rgba(255,255,255,0.2)" }} />
        <ListItem>
          <ListItemIcon sx={iconSx}><CalendarToday fontSize="small" /></ListItemIcon>
          <ListItemText primary={formatDate(post.availableFrom)} secondary="Available from" />
        </ListItem>
      </List>
    </Box>
  );
};

export default DetailsSection;
